import AbstractElectronPlatformUpdater
    from "~/operatorApplication/ts/platform/electron/AbstractElectronPlatformUpdater";

export default class Electron22PlatformUpdater extends AbstractElectronPlatformUpdater {
    protected get updateJsonFileName(): string {
        return "update2026.el22.json";
    }

    protected get updateZipDirectory(): string {
        return "el22";
    }
}